<template>
    <div class="TheTableSearch">
        <!--SEARCH ICON-->
        <BaseNavigationButton @click="search()"
                              :icon="'icon-search'"
                              :class-name="'TheTableSearch__search'" />
        <!--SEARCH FILTER TEXT-->
        <BaseText :label="'TABLE__SEARCH'"
                  :class-name="'TheTableSearch__text'"
                  :value="filter"
                  @change="setFilter($event.target.value)"
                  @enter="search()" />
    </div>
</template>

<script>
    import { mapActions, mapState } from 'vuex';
    import BaseNavigationButton from '../common/BaseNavigationButton.vue';
    import BaseText from '../common/BaseText.vue';

    export default {
        name: 'TheTableSearch',
        components: {
            BaseNavigationButton,
            BaseText
        },
        computed: {
            ...mapState({
                filter: s => s.table.filter
            })
        },
        methods: {
            ...mapActions({
                setFilter: 'table/setFilter',
                search: 'table/search'
            })
        }
    };
</script>

<style>
    .TheTableSearch {
        overflow: hidden;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        cursor: pointer;
        margin: 8px;
        padding: 8px;
        border-radius: 2px;
        box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
        background-color: #ECEFF1;
    }

    .TheTableSearch__search {
        color: #546E7A;
        font-size: 20px;
        margin-right: 8px;
    }

    .BaseText__container.TheTableSearch__text {
        flex: 1 1 auto;
        margin: 0;
    }

    .TheTableSearch__text .BaseText__input {
        border-bottom: none;
        padding: 6px 8px 8px 5px;
    }

    .TheTableSearch__text .BaseText__label {
        top: 6px;
    }

    .TheTableSearch__text .BaseText__input:focus ~ .BaseText__label {
        display: none;
    }

    .TheTableSearch__text .BaseText__input:valid ~ .BaseText__label {
        display: none;
    }

    .TheTableSearch__text .BaseErrors {
        display: none;
    }
</style>



// WEBPACK FOOTER //
// TheTableSearch.vue?181677a8